import { useMutation } from "@tanstack/react-query";

import api from "common/utils/api";
import { objNamesToCamelCase } from "common/utils/helpers/cases";
import type { aiImages } from "common/utils/models";
import { useTokenManagement } from "../model/tokenManagement";

// API function to generate images
const generateAiImages = async ({
  prompt
}: aiImages.generate.Request): Promise<aiImages.generate.Response> => {
  const data = await api.aiImages.generate({ prompt });
  return objNamesToCamelCase(data);
};

export function useGenerateAiImages() {
  const { updateAiCreditsBalance } = useTokenManagement();

  return useMutation({
    mutationFn: generateAiImages,
    onSuccess: data => {
      updateAiCreditsBalance(data.remainingCredits);
    },
    onError: (error: any) => {
      if (error?.response) {
        const response = objNamesToCamelCase(error.response);
        updateAiCreditsBalance(response.remainingCredits);
      }
    }
  });
}
